import { api } from "..";

export function getIndexSummary() {
  return api('/v1/merchantCenter/reports/getIndexSummary')
}